import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductGenericGridALV1Component } from './product-generic-grid-al-v1/product-generic-grid-al-v1.component';
import { ProductGenericGridALV1Service } from './product-generic-grid-al-v1/product-generic-grid-al-v1.service'; 
import { ProductCatalogALV1Service } from './product-generic-grid-al-v1/product-catalog-al-v1.service'; 
import { ProductItemALV1Module } from 'abs-ngx-library/src/lib/product-item-al-v1';
import { ProductItemALV2Module } from 'abs-ngx-library/src/lib/product-item-al-v2';
import { SortByAlV1Module } from 'abs-ngx-library/src/lib/sort';
import { ZoneModule } from 'abs-ngx-library/src/lib/zone';



@NgModule({
  declarations: [ProductGenericGridALV1Component],
  exports: [
    ProductGenericGridALV1Component,
  ],
  imports: [
    CommonModule,
    ProductItemALV1Module,
    ProductItemALV2Module,
    ZoneModule,
    SortByAlV1Module
  ],
  providers: [
    ProductGenericGridALV1Component,
    ProductGenericGridALV1Service,
    ProductCatalogALV1Service
  ]
})
export class ProductGenericGridModule { }
